import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { RefreshCcw } from "lucide-react";

export default function RefundPolicy() {
  return (
    <div className="min-h-dvh bg-[#0B1429] flex flex-col font-sans text-[#E2E8F0]">
      <Navbar />
      <div className="h-20" />
      <main className="flex-grow max-w-4xl mx-auto px-6 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 rounded-2xl bg-[#00F0FF]/10 flex items-center justify-center border border-[#00F0FF]/20">
              <RefreshCcw className="w-6 h-6 text-[#00F0FF]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-display font-black text-white">Refund Policy</h1>
          </div>
          <div className="prose prose-invert max-w-none space-y-4 text-[#94A3B8] leading-relaxed">
            <h3 className="text-white text-xl font-bold mt-8 mb-4">1. Registration & Entry Fees</h3>
            <p>All registration fees, individual event entry fees, relay team entry fees, and administrative fees are strictly non-refundable once the booking or registration is successfully completed and payment is processed. We do not offer refunds for change of mind, inability to attend, medical conditions, or any other circumstances, except where mandatorily required under applicable law.</p>
            
            <h3 className="text-white text-xl font-bold mt-8 mb-4">2. Accommodation & Logistics</h3>
            <p>Payments for official championship accommodation, airport transfers, and local shuttles are final. Once booked, these services cannot be cancelled or refunded through the Organising Committee.</p>
            
            <h3 className="text-white text-xl font-bold mt-8 mb-4">3. Event Cancellation</h3>
            <p>In the unlikely event that the 2nd Asian Masters Swimming Championships 2026 is cancelled or postponed by the Organising Committee or due to Force Majeure (including but not limited to natural disasters, pandemics, government directives, or severe weather conditions), the Organising Committee shall not be liable to refund any fees. Participants will be notified regarding the transfer of registrations to future dates if applicable.</p>
            
            <h3 className="text-white text-xl font-bold mt-8 mb-4">4. Duplicate Payments</h3>
            <p>If a duplicate payment is accidentally processed due to a technical error on the platform, participants must notify the support team within 7 days. Upon verification, the duplicate transaction will be refunded to the original method of payment within 14-21 business days.</p>
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
